import React from "react";
import axios from "axios";
import logo from './logo-white.svg';
import "./App.css";
import { useState } from "react";
import PacmanLoader from "react-spinners/PacmanLoader";

function App() {
  const [apiMsg, setApiMsg ] = useState(null);
  const [loading, setLoading] = useState(false);

  const upload = (e) => {
    const files = e.target.files
    var bodyFormData = new FormData();
    bodyFormData.append('file', files[0]); 
    e.target.value = null;
    setLoading(true);
    axios({
      method: 'POST',
      url: '/api/upload',
      data: bodyFormData,
      headers: {'Content-Type': 'multipart/form-data' }
      })
      .then(response => {
          console.log(response);
          setLoading(false);
          setApiMsg(response.data.message);
      })
      .catch(err => {
          let message = typeof err.response !== "undefined" ? err.response.data.message : err.message;
          console.error(message);
          setLoading(false);
          setApiMsg(message);
      });
  }

  return (
    <div className="App">
      <header className="App-header">
      <img src={logo} className="App-logo" alt="logo" />
      <h3>Select .h5p file from your local filesystem.</h3>
	    <input type='file' onChange={(e) => upload(e)} name='img' />
      {apiMsg && <p>{apiMsg}</p>}
      <div className="sweet-loading">
        <PacmanLoader color='#FFF' loading={loading} size={50} />
      </div>
      </header>
    </div>
  );
}

export default App;